<!DOCTYPE html>
<ion-content style="--background: transparent;">
  <ion-grid class="ion-no-padding store-wrapper">
    <ion-row>
      <div class="store-card">
        <img src="../../../../assets/images/WMP_Group.png" alt="WinMore-banner" />
      </div>
    </ion-row>
    <ion-row>
      <div class="title-wrapper">
        <p class="above-title">{{'win_more_promise.exclusive'| translate}}</p>
        <h2 class="title">{{'win_more_promise.promise'| translate}}</h2>
        <p class="sub-title">{{'win_more_promise.win_more'| translate}}</p>
      </div>
      <div class="quote-wrapper">
        <ion-grid>
          <ion-row>
            <ion-col size="2">
              <img class="user-review" src="../../../../assets/images/reviewuser.png" alt="WinMore-user" />
            </ion-col>
            <ion-col size="10">
              <p class="quote-block">“{{'win_more_promise.joining'| translate}}”</p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-row>
    <div class="btn-wrapper">
      <ion-button expand="block" color="secondary" class="capsule-btn common-margin syndicate-btn"
        (click)="showPromisePopup()">
        {{'win_more_promise.tell_more'| translate}}
      </ion-button>
    </div>
  </ion-grid>
</ion-content>
